import { createContext, useState } from "react";

export const CompanyProfileContext = createContext();

export function CompanyProfileProvider({ children }) {
  const [companyProfile, setCompanyProfile] = useState({});

  return (
    <CompanyProfileContext.Provider
      value={{ companyProfile, setCompanyProfile }}
    >
      {children}
    </CompanyProfileContext.Provider>
  );
}
